import CityLandingPage from './CityLandingPage';
import { cityPages } from '@/mocks/cityPages';

const data = cityPages.find((c) => c.slug === 'electronics-recycling-torrance')!;

const TorrancePage = () => <CityLandingPage data={data} />;

export default TorrancePage;
